import React from 'react'
import { Alert, Button } from 'react-bootstrap'
import { ISupportSpinner } from '../shared/Ajax'
import { Backdrop } from '../shared/Backdrop'
import { TimeoutPopup } from '../shared/TimeoutPopup'
import { CacheFetch } from '../controllers/CacheFetch'
import { CacheItem } from '../models/CacheItem'
import { Table, TableColumn } from '../shared/table'

export interface AdminPageProps {
}

export interface AdminPageState{
    loading: boolean
    error: boolean
    statusMessage: string,
    cacheItems: CacheItem[],
}

export class AdminPage extends React.Component<AdminPageProps, AdminPageState> implements ISupportSpinner {
  cacheFetch: CacheFetch

  cacheItemTableColumns: TableColumn<CacheItem>[] = [
    { name: 'Key', content: (d) => d.key },
    { name: 'Display Name', content: (d) => d.displayName },
    { name: 'Display Value', content: (d) => d.displayValue },
    {
      name: '',
      content: (d) => (
        <a href="#" onClick={(e) => { e.preventDefault(); this.handleClearClick(d.key) }}>Clear</a>
      ),
    },
  ]

  constructor(props: AdminPageProps) {
    super(props)

    this.cacheFetch = new CacheFetch()

    this.state = {
      loading: false,
      error: false,
      statusMessage: null,
      cacheItems: [],
    }
  }

  componentDidMount() {
    this.refreshCacheItemsTable()
  }

  toggleSpinner(on: boolean, callback: { (): any }): void {
    this.setState({ loading: on }, callback)
  }

  async refreshCacheItemsTable() {
    this.cacheFetch.getAllCacheItems()
      .then((data) => {
        this.setState({ cacheItems: data })
      })
      .catch((error) => {
        this.setState({ error: true, statusMessage: 'Error loading cache items' })
        console.error('Error: Load cache items', error)
      })
  }

  handleClearClick = (cacheKey: string) => {
    this.setState({ error: false, statusMessage: null })

    this.cacheFetch.clearCacheItem(cacheKey)
      .then(() => {
        this.refreshCacheItemsTable()
        this.setState({ statusMessage: 'Cache item cleared successfully' })
      })
      .catch((error) => {
        this.setState({ error: true, statusMessage: 'Error clearing cache item' })
        console.error('Error: Clear cache item', error)
      })
  }

  handleClearAllClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()

    this.setState({ error: false, statusMessage: null })

    this.cacheFetch.clearAllCacheItems()
      .then(() => {
        this.refreshCacheItemsTable()
        this.setState({ statusMessage: 'All cache items cleared successfully' })
      })
      .catch((error) => {
        this.setState({ error: true, statusMessage: 'Error clearing all cache items' })
        console.error('Error: Clear all cache items', error)
      })
  }

  handleRefreshClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()

    this.setState({ error: false, statusMessage: null })
    this.refreshCacheItemsTable()
  }

  render() {
    const {
      error, statusMessage, loading, cacheItems,
    } = this.state

    return (
      <div className="container-fluid pt-2">
        <div className="row">
          <div className="col-lg-9">
            <h2>Admin Dashboard</h2>

            <Table<CacheItem>
              header={(
                <div className="row">
                  <div className="mr-2">
                    <Button
                      id="btnClearAll"
                      className="emdg-btn btn btn-primary"
                      onClick={this.handleClearAllClick}
                    >
                      Clear All
                    </Button>
                  </div>
                  <div>
                    <Button
                      id="btnRefresh"
                      className="emdg-btn btn btn-primary"
                      onClick={this.handleRefreshClick}
                    >
                      Refresh
                    </Button>
                  </div>
                </div>
              )}
              label="Application Cache Items"
              id="cacheItemsTable"
              value={cacheItems}
              columns={this.cacheItemTableColumns}
              required
              visible
              alwaysShowAllRows
            />

            {(error || statusMessage) && (
            <Alert className={`emdg-page-alerts ${error ? 'emdg-page-alerts--error' : ''}`}>
              {statusMessage}
            </Alert>
            )}

            <Backdrop on={loading} />
          </div>
        </div>
        <TimeoutPopup />
      </div>
    )
  }
}
